import { Tabs } from "antd";
import { useState } from "react";
import TableTab from "./TableTab";
import CompareTab from "./CompareTab";

function SubError({ tabActive, handleGetData }) {
  const [tabKey, setTabKey] = useState("airtime-error-table");
  return (
    <Tabs
      activeKey={tabKey}
      onChange={setTabKey}
      items={[
        {
          key: "airtime-error-table",
          label: 'Detail Table',
          children: <TableTab handleGetData={handleGetData} tabActive={tabKey} />
        },
        {
          key: "airtime-error-compare",
          label: 'Compare Chart',
          children: <CompareTab handleGetData={handleGetData} tabActive={tabKey} />
        }
      ]}
    >
      
    </Tabs>
  );
}

export default SubError;
